$(document).ready(function(){
$(document).on("click",".new_table_wrapp td.add_cart_btn button.add_to_cart_btn.btn", function(){
   
var data_id = $(this).attr("data-id");
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: { id: data_id          },
dataType: 'json',
success: function (data) {
document.dispatchEvent(new CustomEvent('cart:build'));
$("html").addClass("cart-open");
$(".site-header__cart").addClass("is-active");

    jQuery.getJSON('/cart.js', function(cart) {
      console.log(cart);
   var original_price = cart.total_price,
    total_goal = $(".sidebar_progress_bar").attr("data-goal"),
      final_result = (original_price/100),
     final_val = parseInt(total_goal) - parseInt(final_result);
       $(".sidebar_progress_bar progress").val(final_result);
             if(final_result >= total_goal){
             $("span.minus_val").hide();
               $(".free_shipping_text").show();
            }else if(final_result < total_goal){
              $("span.minus_val span.price_append").html(theme.Currency.formatMoney(final_val+".00", theme.settings.moneyFormat));
              $("span.minus_val").show();
               $(".free_shipping_text").hide();
            }
  }); 

 $('.custom_new-grid.cat_reco_slider').slick({
   slidesToShow: 2,
   slidesToScroll: 1,
    prevArrow:'<div class="reco-prev-slide custom-slider"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L2.41421 7L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z" fill="#767676"/></svg></div>',
   nextArrow:'<div class="reco-next-slide custom-slider"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7.70711 6.29289C8.09763 6.68342 8.09763 7.31658 7.70711 7.70711L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="black"/></svg></div>',
     dots:true,
   fade: false
 });
        setTimeout(function() {
           $('.custom_new-grid.cat_reco_slider').slick('resize'); 
           $('.custom_new-grid.cat_reco_slider').slick('setPosition'); 
        },500);
  
},
error: function (jqXHR, textStatus, errorThrown) { console.log("error"); }
});
});
$(document).on("click",".js-close-header-cart",function() {
$("html").removeClass("cart-open");
$(".site-header__cart").removeClass("is-active");
});
$("td.graph_image svg").click(function() {
   var Graph_data = $(this).parents(".graph_image").attr("data-handle");
 
  if(Graph_data == 'goldgraph'){
      $("section.custom_graph_popup").show();
  $("select#jschart_miniChartModeAxis").hide();
       $("span#jschart_AUX").show();
      $("span#jschart_AUX").trigger("click");
      $("span#jschart_AGX").hide();
  }else if(Graph_data == 'silvergraph'){
       $("section.custom_graph_popup").show();
  $("select#jschart_miniChartModeAxis").hide();
       $("span#jschart_AUX").hide();
      $("span#jschart_AGX").trigger("click");
      $("span#jschart_AGX").show();
  }
});
  $(".custom_graph_popup .graph_popup__content .close").click(function() {
  $(".custom_graph_popup").fadeOut(500);
});
});